// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"3bf3ae08","123":"3860ea20"}[chunkId] + ".chunk.css";
};